import type { TechniqueDefinition } from "./TechniqueDefinition.js";

export const palmaRestauradora: TechniqueDefinition = {
  id: "palma_restauradora",
  name: "Palma Restauradora",
  description: "Restores an ally's health with concentrated medical chakra.",
  family: "medical_ninjutsu",
  proficiency: "ninjutsu",
  targeting: "ally_injured",
  behavior: { kind: "healing" },
  levels: {
    1: {
      chakraCost: 20,
      cooldownMs: 6_000,
      range: 180,
      maxTargets: 1,
      power: 18,
      attackCoefficient: 1,
      injuredHpThreshold: 0.7,
    },
    2: {
      chakraCost: 20,
      cooldownMs: 6_000,
      range: 180,
      maxTargets: 1,
      power: 19,
      attackCoefficient: 1.04,
      injuredHpThreshold: 0.7,
    },
    3: {
      chakraCost: 21,
      cooldownMs: 6_000,
      range: 180,
      maxTargets: 1,
      power: 20,
      attackCoefficient: 1.08,
      injuredHpThreshold: 0.7,
    },
    4: {
      chakraCost: 21,
      cooldownMs: 6_000,
      range: 180,
      maxTargets: 1,
      power: 21,
      attackCoefficient: 1.12,
      injuredHpThreshold: 0.7,
    },
    5: {
      chakraCost: 22,
      cooldownMs: 6_000,
      range: 180,
      maxTargets: 1,
      power: 22,
      attackCoefficient: 1.16,
      injuredHpThreshold: 0.7,
    },
    6: {
      chakraCost: 23,
      cooldownMs: 6_000,
      range: 180,
      maxTargets: 1,
      power: 23,
      attackCoefficient: 1.2,
      injuredHpThreshold: 0.7,
    },
    7: {
      chakraCost: 24,
      cooldownMs: 6_000,
      range: 180,
      maxTargets: 1,
      power: 24,
      attackCoefficient: 1.24,
      injuredHpThreshold: 0.7,
    },
    8: {
      chakraCost: 25,
      cooldownMs: 6_000,
      range: 180,
      maxTargets: 1,
      power: 25,
      attackCoefficient: 1.28,
      injuredHpThreshold: 0.7,
    },
    9: {
      chakraCost: 26,
      cooldownMs: 6_000,
      range: 180,
      maxTargets: 1,
      power: 26,
      attackCoefficient: 1.32,
      injuredHpThreshold: 0.7,
    },
    10: {
      chakraCost: 27,
      cooldownMs: 6_000,
      range: 180,
      maxTargets: 1,
      power: 28,
      attackCoefficient: 1.35,
      injuredHpThreshold: 0.7,
    },
  },
  visual: { effectId: 161 },
};
